<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">{{ currentTitle }}</h2>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="30px">
    <div
      fxFlex="grow"
      class="ui vertical basic segment"
      [ngClass]="{ loading: pending }"
    >
      <div
        class="ui padded segment no-border"
        fxLayout="column"
        appPadding="10"
        id="bg-color"
      >
        <!-- <div appMargin marginB="10" class="sub-value">
          Company details you provided
        </div> -->

        <div
          fxFlex
          fxLayout="row"
          fxLayoutAlign="space-between start"
          appMargin
          marginB="10"
        >
          <div fxFlex>
            <div class="sub-label">COMPANY OWNERSHIP TYPE</div>
            <div class="sub-value">{{ ownership?.optionName }}</div>
          </div>

          <div fxFlex>
            <div class="sub-label">COMPANY TYPE</div>
            <div class="sub-value">{{ company?.optionName }}</div>
          </div>
        </div>

        <div fxFlex fxLayout="row" fxLayoutAlign="space-between start">
          <div fxFlex>
            <div class="sub-label">COMPANY RC/BN NUMBER</div>
            <div class="sub-value">{{ userObject.rc_number }}</div>
          </div>

          <div fxFlex>
            <div class="sub-label">COMPANY TAX IDENTIFICATION NUMBER (TIN)</div>
            <div class="sub-value">{{ userObject.tin_number }}</div>
          </div>
        </div>
      </div>

      <div
        class="ui tertiary segment no-border"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        *ngIf="!isSendMessage"
      >
        <!-- <div fxFlex="7%">
          <i class="exclamation triangle big colored primary icon"></i>
        </div> -->
        <div fxFlex="7%">
          <img src="assets/images/caution.svg" alt="exclamation icon" />
        </div>

        <div fxFlex class="msg">
          You are allowed a maximum of 3 attempts. You have
          {{ tries }} out of 3 attempts left. If you are unable to proceed with
          your registration,
          <span><a class="link" (click)="showFormMsg()">click here</a></span>
          to send us a message.
        </div>
      </div>

      <!--  -->
      <ng-template [ngIf]="errorMessg">
        <div
          class="ui segment light no-border"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="7%">
            <i class="exclamation circle big colored red icon"></i>
          </div>
          <div fxFlex>
            Oops!
            <h4>
              The company with the details provided is already registered in NCC
              Database.
            </h4>
            <p>
              Sign in with your username and password to access the company
              account. If you cannot remember your username and password,
              <a routerLink="/home-page/forgot-password">Click here</a> to reset
              it. For any other complaint or feedback,
              <a routerLink="/home-page/contact">Click here</a>.
            </p>
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="tinErrorMessage">
        <div
          class="ui segment light no-border"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="7%">
            <i class="exclamation circle big colored red icon"></i>
          </div>
          <div fxFlex>
            Oops!
            <h4>
              The Provided TIN number is already registered with another company
            </h4>
          </div>
        </div>
      </ng-template>
      <!--  -->

      <ng-template [ngIf]="noRecord">
        <div
          class="ui segment light no-border"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="7%">
            <i class="exclamation circle big colored primary icon"></i>
          </div>
          <div fxFlex>
            <strong>Oops!</strong> The system was unable to match the company
            information you provided with a record in our database. You may
            provide your company details again by clicking on the
            <strong>Provide Details Again </strong> button below or click on the
            <strong>Report Issue</strong> button to report the issue.
          </div>
        </div>
        <div class="ui right floated buttons">
          <button
            class="ui primary basic button"
            routerLink="/home-page"
            appMargin
            marginR="10px"
          >
            Exit
          </button>
          <button
            class="ui primary basic button"
            routerLink="/home-page/contact"
            appMargin
            marginR="10px"
          >
            Report Issue
          </button>
          <button
            class="ui primary basic button"
            (click)="provideDetailAgain()"
          >
            Provide Details Again
          </button>
        </div>
      </ng-template>

      <!-- <ng-template [ngIf]="isSendMessage">
        <div class="" appMargin appPadding paddingB="30">
          <div *ngIf="successMsg || errorMsg" tamsyMargin marginY="10px">
            <esl-message-toast
              [(message)]="successMsg"
              [messageType]="'success'"
            ></esl-message-toast>
            <esl-message-toast [(message)]="errorMsg"></esl-message-toast>
          </div>

          <div class="ui basic segment">
            <form class="ui form" [formGroup]="msgForm">
              <div class="required field">
                <label>Enter your Email Address </label>
                <input type="email" name="email" formControlName="email" />
              </div>
              <div class="required field">
                <label>Enter your Company Name </label>
                <input type="text" name="name" formControlName="companyName" />
              </div>

              <div class="required field">
                <label>Message</label>
                <textarea formControlName="message"></textarea>
              </div>

              <button
                class="ui primary button"
                [ngClass]="{ 'yellow loading': pending }"
                (click)="sendMsg()"
                [disabled]="!msgForm.valid"
              >
                Submit
              </button>
            </form>

            <div
              class="ui basic segment"
              appMargin
              appPadding
              marginT="25px"
              paddingX="0"
            >
              <button class="ui basic button" (click)="removeFormMsg()">
                Exit
              </button>

              <button
                class="ui right floated primary button"
                (click)="sendMsg()"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </ng-template> -->

      <ng-template [ngIf]="provideDetail">
        <div class="ui segment light no-border">
          <div
            class="ui form"
            [formGroup]="detailForm"
            [ngClass]="{ loading: pending }"
          >
            <div
              class="field required"
              [ngClass]="displayFieldCss('tin_number')"
            >
              <label>Company RC Number</label>
              <inline-editor
                type="text"
                [(ngModel)]="userObject.rc_number"
                (onSave)="saveEditable($event, 'rc_number')"
                formControlName="rc_number"
                (onError)="myHandleError()"
              ></inline-editor
              ><br />
              <small
                ><i class="idea icon"></i>Click on the pencil icon to edit your
                RC Number. Press Enter when you are done editing.</small
              >
              <!-- <input type="text" placeholder="05002743-0001" formControlName="rc_number" [(ngModel)]="valuesProvided.rc_number"> -->
              <app-field-error-display
                [displayError]="isFieldValid('tin_number')"
                errorMsg="Please enter company TIN Number"
              >
              </app-field-error-display>
            </div>

            <div class="ui divider"></div>

            <div
              class="field required"
              [ngClass]="displayFieldCss('tin_number')"
            >
              <label>Company Tax Identification Number (TIN)</label>
              <small
                >(This is a unique number allocated and issued to your company
                by FIRS as a duly registered Taxpayer in Nigeria .)</small
              ><br />
              <inline-editor
                type="text"
                [(ngModel)]="userObject.tin_number"
                (onSave)="saveEditable($event, 'tin_number')"
                formControlName="tin_number"
                (onError)="myHandleError()"
              ></inline-editor
              ><br />
              <small
                ><i class="idea icon"></i> Click on the pencil icon to edit your
                RC Number. Press Enter when you are done editing.</small
              >
              <!-- <input type="text" placeholder="05002743-0001" formControlName="tin_number" [(ngModel)]="userObject.tin_number"> -->
              <!-- <app-field-error-display
                                [displayError]="isFieldValid('tin_number')"
                            errorMsg="Please enter company TIN Number">
                        </app-field-error-display> -->
            </div>

            <div class="ui divider"></div>

            <div class="field" [ngClass]="displayFieldCss('company_type')">
              <label>What is your company type</label>
              <inline-editor
                type="select"
                [(ngModel)]="userObject.company_type"
                (onSave)="saveEditable($event, 'company_type')"
                formControlName="company_type"
                [options]="companyType"
                (onError)="myHandleError()"
              ></inline-editor
              ><br />
            </div>

            <div class="ui divider"></div>

            <!-- <div class="field required"  [ngClass]="displayFieldCss('nccId')">
                        <label>License Number issued by NCC</label>
                        <small>(If you applied and was issued a License by NCC, please enter your License number below.)</small><br/>
                          <inline-editor
                        type="text"
                        [(ngModel)]="userObject.nccId"
                        (onSave)="saveEditable($event,'nccId')"
                        formControlName="nccId"
                        (onError)="myHandleError()"></inline-editor><br/>
                        <small><i class="idea icon"></i> Click on the pencil icon to edit your RC Number. Press Enter when you are done editing.</small>
					</div> -->
          </div>
        </div>

        <div
          class="ui box segment"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          id="section"
        >
          <div fxFlex (click)="goBack()" class="link">
            <i class="arrow left colored primary icon"></i>
          </div>
          <div>
            <button class="ui primary button" (click)="submitDetail()">
              Submit
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="verifyDetail">
        <div appMargin marginY="10" class="msg-info">
          Please verify your company name below
        </div>

        <div appMargin marginB="10">
          Is the name of your company
          <strong class="ui primary header"
            >“{{ validatedRecord?.cacRecord?.companyName }}”?</strong
          >
        </div>

        <div class="ui form">
          <div class="grouped fields">
            <div class="field">
              <sui-radio-button
                name="example"
                value="true"
                [(ngModel)]="isCorrect"
                >Yes</sui-radio-button
              >
            </div>
            <div class="field">
              <sui-radio-button
                name="example"
                value="false"
                [(ngModel)]="isCorrect"
                >No</sui-radio-button
              >
            </div>
          </div>
          <div class="required field" *ngIf="isCorrect == 'false'">
            <label for="">Please enter the correct company name below</label>
            <input
              type="text"
              name="name"
              [(ngModel)]="companyName"
              placeholder=""
            />
          </div>
        </div>

        <div
          class="ui box segment"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          id="section"
        >
          <div fxFlex (click)="goBack()" class="link">
            <i class="arrow left colored primary icon"></i>
          </div>
          <div>
            <button class="ui primary button" (click)="submitName()">
              Proceed
            </button>
          </div>
        </div>
      </ng-template>
      <!-- <sui-dimmer class="inverted" [(isDimmed)]="pending" isClickable="false">
          <div class="ui text loader">Loading...</div>
      </sui-dimmer> -->
    </div>

    <div
      fxFlex="30%"
      fxHide.lt-sm="true"
      fxLayout="column"
      class="ui vertical basic segment"
      [ngClass]="{ loading: mpending }"
    >
      <div class="side" appPadding="7">
        <div [innerHtml]="registrationSidebar"></div>
      </div>
    </div>
  </div>
</div>
